import {_BASIC_TRANSACTIONS,
        PURCHASE_CORRECTION_SUCCESS, PURCHASE_CORRECTION_FAIL, PURCHASE_CORRECTION_SENT,
        PURCHASE_SENT, PURCHASE_SUCCESS, PURCHASE_FAIL,
        PREAUTH_COMPLETION_SUCCESS, PREAUTH_COMPLETION_SENT, PREAUTH_COMPLETION_FAIL,
        PREAUTH_SUCCESS, PREAUTH_FAIL, PREAUTH_SENT,
        FORCE_POST_SUCCESS, FORCE_POST_FAIL, FORCE_POST_SENT,
        REFUND_SUCCESS, REFUND_FAIL, REFUND_SENT,
        INDEPENDENT_REFUND_SUCCESS, INDEPENDENT_REFUND_FAIL, INDEPENDENT_REFUND_SENT,
        OPEN_TOTALS_SUCCESS, OPEN_TOTALS_FAIL, OPEN_TOTALS_SENT,
        BATCH_CLOSE_SUCCESS, BATCH_CLOSE_FAIL, BATCH_CLOSE_SENT,
        CARD_VERIFICATION_SUCCESS, CARD_VERIFICATION_FAIL, CARD_VERIFICATION_SENT,
        UPDATE_PREV_SUCC_STEP, UPDATE_TXN_NUMBER, CLEAR_HISTORY, UPDATE_ORDER_ID
    } from './types'

    const HOST = "https://developer.moneris.com/demoapi"
    //http://monerisdeveloperauth.monad.moneris.com:8081
//https://localhost:5001
//https://developer.moneris.com:8081

export const setErrorMessage = (err, actionType) => dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: actionType, payload: err });
}

export const makePurchase = (purchaseRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: PURCHASE_SENT });
    dispatch({ feature: _BASIC_TRANSACTIONS, type: CLEAR_HISTORY });

    const { storeId, apiToken, orderId, pan, expdate, amount } = purchaseRequest;
    try {
        let response = await fetch(`${HOST}/api/transactions/purchase`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "HostId = " + responseJson.HostId+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';

        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_ORDER_ID, payload: responseJson.ReceiptId });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: PURCHASE_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 1 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: PURCHASE_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePreauth = (preAuthRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: PREAUTH_SENT });


    const { storeId, apiToken, orderId, pan, expdate, amount } = preAuthRequest;
    try {
        let response = await fetch(`${HOST}/api/transactions/preauth`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';

        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_ORDER_ID, payload: responseJson.ReceiptId });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: PREAUTH_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 2 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: PREAUTH_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePreauthCompletion = (preAuthCompRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: PREAUTH_COMPLETION_SENT });

    const { storeId, apiToken, orderId, amount, txnNumber } = preAuthCompRequest;

    console.log(orderId);
    console.log(txnNumber);

    try {
        let response = await fetch(`${HOST}/api/transactions/preauthcompletion`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                amount: amount,
                txn_number: txnNumber
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';

        if(responseJson.TxnNumber)
            dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: PREAUTH_COMPLETION_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 3 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: PREAUTH_COMPLETION_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeForcePost = (forcePostRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: FORCE_POST_SENT });
    dispatch({ feature: _BASIC_TRANSACTIONS, type: CLEAR_HISTORY });

    const { storeId, apiToken, orderId, pan, expdate, amount } = forcePostRequest;
    try {
        let response = await fetch(`${HOST}/api/transactions/forcepost`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "CorporateCard = " + responseJson.CorporateCard+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';

        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_ORDER_ID, payload: responseJson.ReceiptId });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: FORCE_POST_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 4 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: FORCE_POST_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePurchaseCorrection = (purchaseCorrectionRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: PURCHASE_CORRECTION_SENT });


    const { storeId, apiToken, orderId, txnNumber } = purchaseCorrectionRequest;
    try {
        let response = await fetch(`${HOST}/api/transactions/purchasecorrection`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                txn_number: txnNumber
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';

        dispatch({ feature: _BASIC_TRANSACTIONS, type: PURCHASE_CORRECTION_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 5 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: PURCHASE_CORRECTION_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeRefund = (refundRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: REFUND_SENT });


    const { storeId, apiToken, orderId, amount, txnNumber } = refundRequest;
    try {
        let response = await fetch(`${HOST}/api/transactions/refund`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                amount: amount,
                txn_number: txnNumber
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
       

        dispatch({ feature: _BASIC_TRANSACTIONS, type: REFUND_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 6 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: REFUND_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeIndependentRefund = (indRefundRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: INDEPENDENT_REFUND_SENT });


    const { storeId, apiToken, orderId, pan, expdate, amount } = indRefundRequest;
    try {
        let response = await fetch(`${HOST}/api/transactions/independentrefund`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';

        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_ORDER_ID, payload: responseJson.ReceiptId });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: INDEPENDENT_REFUND_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 7 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: INDEPENDENT_REFUND_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeCardVerification = (cardVerificationRequest) => async dispatch => {
    dispatch({ feature: _BASIC_TRANSACTIONS, type: CARD_VERIFICATION_SENT });
    const { storeId, apiToken, orderId, pan, expdate } = cardVerificationRequest;

    try {
        let response = await fetch(`${HOST}/api/transactions/cardverification`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
            }),
        })

        let responseJson = await response.json();
        var output = "";

        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount+ '\n';
        output += "TxnNumber = " + responseJson.TxnNumber+ '\n';
        output += "ReceiptId = " + responseJson.ReceiptId+ '\n';
        output += "TransType = " + responseJson.TransType+ '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum+ '\n';
        output += "ResponseCode = " + responseJson.ResponseCode+ '\n';
        output += "ISO = " + responseJson.ISO+ '\n';
        output += "BankTotals = " + responseJson.BankTotals+ '\n';
        output += "Message = " + responseJson.Message+ '\n';
        output += "AuthCode = " + responseJson.AuthCode+ '\n';
        output += "Complete = " + responseJson.Complete+ '\n';
        output += "TransDate = " + responseJson.TransDate+ '\n';
        output += "TransTime = " + responseJson.TransTime+ '\n';
        output += "Ticket = " + responseJson.Ticket+ '\n';
        output += "TimedOut = " + responseJson.TimedOut+ '\n';
        output += "IsVisaDebit = " + responseJson.IsVisaDebit+ '\n';
        output += "IssuerId = " + responseJson.IssuerId+ '\n';

        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_ORDER_ID, payload: responseJson.ReceiptId });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: CARD_VERIFICATION_SUCCESS, payload: output });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 8 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: CARD_VERIFICATION_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeBatchClose = (batchCloseRequest) => async dispatch => {
    const { storeId, apiToken, ecrNumber } = batchCloseRequest;
    dispatch({ feature: _BASIC_TRANSACTIONS, type: BATCH_CLOSE_SENT });

    try {
        let response = await fetch(`${HOST}/api/transactions/batchclose`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                ecr_no: ecrNumber,
            }),
        })

        let responseJson = await response.json();
        const output = responseJson.output;

        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 9 });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: BATCH_CLOSE_SUCCESS, payload: output });

    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: BATCH_CLOSE_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeOpenTotals = (openTotalsRequest) => async dispatch => {
    const { storeId, apiToken, ecrNumber } = openTotalsRequest;
    dispatch({ feature: _BASIC_TRANSACTIONS, type: OPEN_TOTALS_SENT });

    try {
        let response = await fetch(`${HOST}/api/transactions/opentotals`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                ecr_no: ecrNumber,
            }),
        })

        let responseJson = await response.json();
        const output = responseJson.output;

        dispatch({ feature: _BASIC_TRANSACTIONS, type: UPDATE_PREV_SUCC_STEP, payload: 10 });
        dispatch({ feature: _BASIC_TRANSACTIONS, type: OPEN_TOTALS_SUCCESS, payload: output });

    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _BASIC_TRANSACTIONS, type: OPEN_TOTALS_FAIL, payload: 'Error, please try again.'});
    }
}

